module.exports = __webpack_public_path__ + "a3cd543858564a6ea1edb94e3253f9e1.svg";